import { NgModule } from '@angular/core';
import { JobService } from './job.service';
import { JobBackend } from './job.backend';

@NgModule({
  providers: [JobService, JobBackend],
})
export class JobModule {}
